import {RootStoreState} from '../../stores/RootStoreState';

export const getProductTitle = (state: RootStoreState): string => {
  return state.product.name;
};
